'use strict';

exports.__esModule = true;
exports.default = NoExposedMethodError;
function NoExposedMethodError(message) {
  this.name = 'NoExposedMethodError';
  this.message = message;
}

NoExposedMethodError.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/NoExposedMethodError.js
// module id = ysIX
// module chunks = 0